// extracted by mini-css-extract-plugin
export default {"container":"MTnPS2JJ4hreJEZmubRbcw=="};